import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";
import { GetLanguageString, NoResult } from "../helper/Components";
import { addMember } from "../member/ApiMember";
import moment from "moment";
import { LoadingSpinner, convertUTCToLocalTime } from "../../constants/const";
import Draggable from "react-draggable";

const AddNewRafiqRequestSimilarRecords = ({
  setSimilarRecordsModal,
  similarRecords,
}) => {
  const toggle = () => setSimilarRecordsModal(false);
  const [loading, setLoading] = useState(false);
  const [exactMatchRecords, setExactMatchRecords] = useState();
  const [similarMatchRecords, setSimilarMatchRecords] = useState();
  const [cnicMatchRecords, setCnicMatchRecords] = useState();

  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };
  useEffect(() => {
    setLoading(true);
    addMember()
      .GetMemberSimilarRecords(similarRecords)
      .then((res) => {
        setCnicMatchRecords(res.data.cnicRecords);
        setExactMatchRecords(res.data.exactMatchRecords);
        setSimilarMatchRecords(res.data.similarRecords);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [similarRecords]);

  // const seeDetailedData = (memberId, memberUnitId) => {

  //   history.push({
  //     pathname: `member/updateMember/${memberId}`,
  //     state: {
  //       unitId: unit.unitId,
  //       currentUnitId: memberUnitId,
  //       unitName: unit.unitName,
  //       canModifyType: true,
  //       addNewRafiq: true,
  //     },
  //   });
  // };

  return (
    <div>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal
          size="lg"
          style={{ maxWidth: "980px", width: "100%" }}
          isOpen={true}
          className="inmodal"
        >
          <ModalHeader className="modal-title" tag="h4">
            {
              <GetLanguageString props="notifications_see_changes_similar_records" />
            }
          </ModalHeader>
          <ModalBody>
            {!loading ? (
              <>
                <div className="ibox">
                  <div className="ibox-title">
                    <h5>
                      {
                        <GetLanguageString props="notifications_see_changes_similar_records_exact" />
                      }
                    </h5>
                  </div>
                  <div className="ibox-content">
                    <div>
                      {exactMatchRecords?.length !== 0 ? (
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th className="text-center">
                                {<GetLanguageString props="member_reg_number" />}
                              </th>
                              <th className="text-center">
                                {<GetLanguageString props="member_first_name" />}
                              </th>
                              <th className="text-center">
                                {
                                  <GetLanguageString props="member_fathers_name" />
                                }
                              </th>
                              <th className="text-center">
                                {
                                  <GetLanguageString props="member_date_of_birth" />
                                }
                              </th>
                              <th className="text-center">
                                {<GetLanguageString props="member_cnic" />}
                              </th>
                              {/* <th className="text-center">
                          {<GetLanguageString props="common_action" />}
                        </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {exactMatchRecords?.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td className="text-center no-drag">{item.regNo}</td>
                                  <td className="text-center ur no-drag">{item.name}</td>
                                  <td className="text-center ur no-drag">
                                    {item.fatherName}
                                  </td>
                                  <td className="text-center no-drag">
                                    {moment(
                                      convertUTCToLocalTime(item.dateOfBirth)
                                    ).format("DD/MM/yyyy")}
                                  </td>
                                  <td className="text-center no-drag">
                                    {item.cnic?.replace(
                                      /(\d{5})(\d{7})(\d{1})/,
                                      "$1-$2-$3"
                                    )}
                                  </td>
                                  {/* <td className="text-center">
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => seeDetailedData(item.id)}
                              >
                                Details
                              </Button>
                            </td> */}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      ) : (
                        <NoResult />
                      )}
                    </div>
                  </div>
                </div>

                <br></br>
                <div className="ibox">
                  <div className="ibox-title">
                    <h5>
                      {
                        <GetLanguageString props="notifications_see_changes_similar_records_similar" />
                      }
                    </h5>
                  </div>
                  <div className="ibox-content">
                    <div>
                      {similarMatchRecords?.length !== 0 ? (
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th className="text-center">
                                {<GetLanguageString props="member_reg_number" />}
                              </th>
                              <th className="text-center">
                                {<GetLanguageString props="member_first_name" />}
                              </th>
                              <th className="text-center">
                                {
                                  <GetLanguageString props="member_fathers_name" />
                                }
                              </th>
                              <th className="text-center">
                                {
                                  <GetLanguageString props="member_date_of_birth" />
                                }
                              </th>
                              <th className="text-center">
                                {<GetLanguageString props="member_cnic" />}
                              </th>
                              {/* <th className="text-center">
                          {<GetLanguageString props="common_action" />}
                        </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {similarMatchRecords?.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td className="text-center no-drag">{item.regNo}</td>
                                  <td className="text-center ur no-drag">{item.name}</td>
                                  <td className="text-center ur no-drag">
                                    {item.fatherName}
                                  </td>
                                  <td className="text-center no-drag">
                                    {moment(
                                      convertUTCToLocalTime(item.dateOfBirth)
                                    ).format("DD/MM/yyyy")}
                                  </td>
                                  <td className="text-center no-drag">
                                    {item.cnic?.replace(
                                      /(\d{5})(\d{7})(\d{1})/,
                                      "$1-$2-$3"
                                    )}
                                  </td>
                                  {/* <td className="text-center">
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => seeDetailedData(item.id)}
                              >
                                Details
                              </Button>
                            </td> */}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      ) : (
                        <NoResult />
                      )}
                    </div>
                  </div>
                </div>
                <br></br>
                <div className="ibox">
                  <div className="ibox-title">
                    <h5>
                      {
                        <GetLanguageString props="notifications_see_changes_similar_records_cnic" />
                      }
                    </h5>
                  </div>
                  <div className="ibox-content">
                    <div>
                      {cnicMatchRecords?.length !== 0 ? (
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th className="text-center">
                                {<GetLanguageString props="member_reg_number" />}
                              </th>
                              <th className="text-center">
                                {<GetLanguageString props="member_first_name" />}
                              </th>
                              <th className="text-center">
                                {
                                  <GetLanguageString props="member_fathers_name" />
                                }
                              </th>
                              <th className="text-center">
                                {
                                  <GetLanguageString props="member_date_of_birth" />
                                }
                              </th>
                              <th className="text-center">
                                {<GetLanguageString props="member_cnic" />}
                              </th>
                              {/* <th className="text-center">
                          {<GetLanguageString props="common_action" />}
                        </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {cnicMatchRecords?.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td className="text-center no-drag">{item.regNo}</td>
                                  <td className="text-center ur no-drag">{item.name}</td>
                                  <td className="text-center ur no-drag">
                                    {item.fatherName}
                                  </td>
                                  <td className="text-center no-drag">
                                    {moment(
                                      convertUTCToLocalTime(item.dateOfBirth)
                                    ).format("DD/MM/yyyy")}
                                  </td>
                                  <td className="text-center no-drag">
                                    {item.cnic?.replace(
                                      /(\d{5})(\d{7})(\d{1})/,
                                      "$1-$2-$3"
                                    )}
                                  </td>
                                  {/* <td className="text-center">
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => seeDetailedData(item.id)}
                              >
                                Details
                              </Button>
                            </td> */}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      ) : (
                        <NoResult />
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              LoadingSpinner()
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={toggle}>
              {<GetLanguageString props="users_role_ok_btn" />}
            </Button>
          </ModalFooter>
        </Modal>
      </Draggable>
    </div>
  );
};

export default AddNewRafiqRequestSimilarRecords;
